import { useRouter } from 'next/router';
import type { CSSProperties } from 'react';
import React from 'react';

import type { ButtonProps } from '@sravni/react-design-system/dist/types/components/Button';

import { fullDealLandingPageRoute } from '@src/shared/constants/pageRoutes';
import { ToFullDealAdvertisingButton } from 'features/FullDeal';
import {
  FULL_DEAL_MOBILE_APP_LINKS,
  FULL_DEAL_MOBILE_APP_SOURCE,
  FULL_DEAL_WEB_TO_WEB_LINKS,
  FULL_DEAL_WEB_TO_WEB_SOURCE,
} from 'features/FullDeal/config';
import { buildHasOfferLinkForFullDeal } from 'features/FullDeal/lib';

import { PromoDealRedirectToAppButton } from '../PromoDealRedirectToAppButton';

import styles from './PromoDealOfferActions.module.scss';
import { PromoDealOffersActionsTexts } from './PromoDealOffersActions.texts';

interface PromoDealOffersActionsProps {
  amount: number;
  term: number;
  toFullDealButtonColor?: ButtonProps['color'];
  className?: string;
  style?: CSSProperties;
}

export const PromoDealOffersActions = ({
  className,
  amount,
  term,
  style,
  toFullDealButtonColor = 'dark',
}: PromoDealOffersActionsProps) => {
  const { asPath } = useRouter();
  const [pathWithoutQuery] = asPath.split('?');
  const isLandingPage = pathWithoutQuery.includes(fullDealLandingPageRoute);

  /**
   * новая ссылка на редирект в приложение
   * @param e f
   */
  const linkWebToApp = isLandingPage
    ? FULL_DEAL_MOBILE_APP_LINKS.FROM_LANDING
    : FULL_DEAL_MOBILE_APP_LINKS.FROM_REFERAL_VITRINA;

  const linkWebToWeb = isLandingPage
    ? FULL_DEAL_WEB_TO_WEB_LINKS.FROM_LANDING
    : FULL_DEAL_WEB_TO_WEB_LINKS.FROM_REFERAL_VITRINA;

  const sourceWebToWeb = isLandingPage
    ? FULL_DEAL_WEB_TO_WEB_SOURCE.FROM_LANDING
    : FULL_DEAL_WEB_TO_WEB_SOURCE.FROM_REFERAL_VITRINA;

  const sourceWebToApp = isLandingPage
    ? FULL_DEAL_MOBILE_APP_SOURCE.FROM_LANDING
    : FULL_DEAL_MOBILE_APP_SOURCE.FROM_REFERAL_VITRINA;

  return (
    <div className={styles.container}>
      <PromoDealRedirectToAppButton
        className={className}
        source={sourceWebToApp}
        link={linkWebToApp}
        buttonColor={toFullDealButtonColor}
      />

      <ToFullDealAdvertisingButton
        as="link"
        variant="secondary"
        className={styles.continueWebsite}
        style={style}
        link={buildHasOfferLinkForFullDeal({
          link: linkWebToWeb,
          amount,
          term,
          showAuth: true,
          ...(isLandingPage && {
            showAuth: true,
            referrer: asPath,
          }),
        })}
        linkTarget="_self"
        color={toFullDealButtonColor}
        size={60}
        block
        source={sourceWebToWeb}
      >
        {PromoDealOffersActionsTexts.continueWebsite}
      </ToFullDealAdvertisingButton>
    </div>
  );
};
